import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ArrowNext } from '../index';
import { withStyles, MenuItem } from '@material-ui/core';
import styles from './styles';

const Amenities = ({ classes, t }) => {
  return (
    <React.Fragment>
      <MenuItem className={classes.wrapper}>
        <i className={`material-icons ${classes.clipboard}`}>assignment</i>
        <span className={classes.title}>{t('mp-information.label.amenities')}</span>
        <ArrowNext classes={classes.arrow} />
      </MenuItem>
    </React.Fragment>
  );
};

Amenities.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(Amenities));
